module.exports = __webpack_public_path__ + "static/media/linux.7ed8a808.png";